(function(angular){
	'use strict';
	
	angular
		.module('reAverageDividendYieldChartModule')
		.directive('reAverageDividendYieldChart', [
			'Highcharts',
			'HIGHCHARTS_OPTIONS',
			'STATIC_BASE_PATH',
			reAverageDividendYieldChart
		]);
	
	function reAverageDividendYieldChart(
		Highcharts,
		HIGHCHARTS_OPTIONS,
		STATIC_BASE_PATH) {
		return {
			replace: true,
			restrict: 'E',
			scope: {},
			templateUrl: STATIC_BASE_PATH + '/' + 'static/html/ria/partials/charts/re-average-dividend-yield-chart.html',
			link: function($scope, $attrs, $elem) {
				
				var categorySubtitles = {
					"Stocks": "VFINX",	
					"Bonds": "AGG",	
					"Real Estate": "REM"	
				};

				Highcharts.setOptions(HIGHCHARTS_OPTIONS());
				
				var chart = new Highcharts.Chart({
					chart: {
						renderTo: "re-average-dividend-yield-chart",
						type: "column"
					},
					series: [{
						data: [{
							color: "hsl(210,10%,80%)",
							y: 2.01
						},{
							color: "hsl(210,10%,80%)",
							y: 3.17
						},{
							color: "#F47735",
							y: 12.01
						}],
						dataLabels: {
							color: "#242628",
							crop: false,
							enabled: true,
							formatter: function() {
								var num = this.y;
								num = num.toFixed(2);
								num = num + "%";
								
								if(this.y === 12.01) {
									return '<span style="fill: hsl(210,5%,15%);">' + num + '</span>';
								} else {
									return '<span style="fill: hsl(210,5%,55%);">' + num + '</span>';
								}
							},
							overflow: "none",
							style: {
								color: '#242628',
								fontSize: '24px',
								letterSpacing: '-.02em'
							}
						},
						states: {
							hover: {
								enabled: false
							}
						}
					}],
					tooltip: {
						enabled: false
					},
					xAxis: {
						categories: ["Stocks", "Bonds", "Real Estate"],
						labels: {
							formatter: function() {
								return("<span class='epsilon' style='color: #55595e;'>" + this.value + "</span><br><span class='zeta'>" + categorySubtitles[this.value] + "</span>");
							},
							style: {
								textAlign: "center"
							},
							useHTML: true
						},
						lineColor: "hsl(210,10%,80%)"
					},
					yAxis: {
						labels: {
							formatter: function() {
								return this.value + "%";
							}
						}
					}
				});
			}
		};
	}
})(window.angular);